var map = {
	"./arrow-down.svg": 4993,
	"./arrow-left.svg": 3834,
	"./arrow-right.svg": 5390,
	"./arrow-up.svg": 622,
	"./book.svg": 738,
	"./building.svg": 5085,
	"./close.svg": 267,
	"./coin.svg": 5258,
	"./credit-card-gear.svg": 323,
	"./dialogue.svg": 4531,
	"./download.svg": 9853,
	"./face-id.svg": 8872,
	"./file.svg": 4127,
	"./files.svg": 6462,
	"./folder.svg": 9901,
	"./grid.svg": 2045,
	"./home.svg": 2472,
	"./hourglass.svg": 2857,
	"./inbox.svg": 1051,
	"./info.svg": 3565,
	"./list.svg": 4753,
	"./login.svg": 6808,
	"./logout.svg": 3447,
	"./menu.svg": 6076,
	"./minus.svg": 6923,
	"./mood-sad.svg": 3063,
	"./play.svg": 8139,
	"./plus.svg": 1021,
	"./profile.svg": 6772,
	"./receipt-long.svg": 8122,
	"./restore.svg": 9785,
	"./search.svg": 5297,
	"./server.svg": 1848,
	"./stars.svg": 7356,
	"./text.svg": 6268,
	"./theme-dark.svg": 8441,
	"./theme-light.svg": 2847,
	"./trending-up.svg": 8092,
	"./user.svg": 5112,
	"./users.svg": 75,
	"./volume.svg": 6991,
	"./widgets.svg": 3592,
	"./zoom-cancel.svg": 583,
	"./zoom-check.svg": 6967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7521;